module.exports = __webpack_public_path__ + "img/img-3.60c27eb3.png";